var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4436 46C44.4436 43.8291 44.4436 42.7437 44.1757 41.8604C43.5724 39.8718 42.0162 38.3156 40.0276 37.7124C39.1443 37.4444 38.0589 37.4444 35.888 37.4444H28.1103C25.9394 37.4444 24.8539 37.4444 23.9707 37.7124C21.9821 38.3156 20.4259 39.8718 19.8226 41.8604C19.5547 42.7437 19.5547 43.8291 19.5547 46M38.9991 25C38.9991 28.866 35.8651 32 31.9991 32C28.1331 32 24.9991 28.866 24.9991 25C24.9991 21.134 28.1331 18 31.9991 18C35.8651 18 38.9991 21.134 38.9991 25Z",
    stroke: "#475467",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser02);
export default __webpack_public_path__ + "static/media/user-02.d59834f7d272d9ff3e6dc42f6ed9aab4.svg";
export { ForwardRef as ReactComponent };